import React, { useEffect, useState } from 'react';
import {
  View, Text, FlatList, TouchableOpacity, StyleSheet,
  ActivityIndicator, Alert,
} from 'react-native';
import { vehiclesAPI } from '../services/api';

const CATEGORIA_LABEL = {
  carro: '🚗 Carro', van: '🚐 Van', caminhao_b: '🚚 Caminhão B',
};

function VehicleCard({ item, onPress }) {
  return (
    <TouchableOpacity style={styles.card} onPress={() => onPress(item)}>
      <View style={styles.cardHeader}>
        <Text style={styles.cardIcon}>{CATEGORIA_LABEL[item.categoria] || '🚗'}</Text>
        <View style={[styles.statusBadge, item.status === 'disponivel' ? styles.badgeGreen : styles.badgeRed]}>
          <Text style={styles.statusText}>{item.status === 'disponivel' ? 'Disponível' : item.status}</Text>
        </View>
      </View>

      <Text style={styles.cardModelo}>{item.modelo}</Text>
      <Text style={styles.cardCidade}>📍 {item.cidade_base} · {item.ano}</Text>
      {item.capacidade_carga && (
        <Text style={styles.cardCarga}>📦 Carga: {item.capacidade_carga} kg</Text>
      )}

      <View style={styles.cardFooter}>
        <Text style={styles.cardPreco}>
          R$ {parseFloat(item.preco_diario).toFixed(2)}
          <Text style={styles.cardPrecoDia}>/dia</Text>
        </Text>
        <TouchableOpacity style={styles.btnVer} onPress={() => onPress(item)}>
          <Text style={styles.btnVerText}>Ver detalhes →</Text>
        </TouchableOpacity>
      </View>

      <Text style={styles.cardProprietario}>👤 {item.proprietario_nome}</Text>
    </TouchableOpacity>
  );
}

export default function SearchResultsScreen({ route, navigation }) {
  const { origem, destino, data, categoria } = route.params;
  const [veiculos, setVeiculos] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: result } = await vehiclesAPI.buscar({ origem, destino, data, categoria });
        setVeiculos(result);
      } catch (err) {
        Alert.alert('Erro', err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <View style={styles.center}>
        <ActivityIndicator size="large" color="#F5C518" />
        <Text style={styles.loadingText}>Buscando veículos...</Text>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {/* Cabeçalho da rota */}
      <View style={styles.routeBar}>
        <Text style={styles.routeText}>{origem}</Text>
        <Text style={styles.routeArrow}>→</Text>
        <Text style={styles.routeText}>{destino}</Text>
        {data && <Text style={styles.routeDate}>· {new Date(data + 'T00:00:00').toLocaleDateString('pt-BR')}</Text>}
      </View>

      <Text style={styles.resultCount}>
        {veiculos.length} veículo{veiculos.length !== 1 ? 's' : ''} encontrado{veiculos.length !== 1 ? 's' : ''}
      </Text>

      {veiculos.length === 0 ? (
        <View style={styles.empty}>
          <Text style={styles.emptyIcon}>🔍</Text>
          <Text style={styles.emptyTitle}>Nenhum veículo disponível</Text>
          <Text style={styles.emptyText}>Tente outra cidade ou data</Text>
        </View>
      ) : (
        <FlatList
          data={veiculos}
          keyExtractor={(item) => String(item.veiculo_id)}
          renderItem={({ item }) => (
            <VehicleCard
              item={item}
              onPress={(v) => navigation.navigate('VehicleDetail', { veiculo: v, origem, destino, data })}
            />
          )}
          contentContainerStyle={{ padding: 16, paddingBottom: 32 }}
          showsVerticalScrollIndicator={false}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container:     { flex: 1, backgroundColor: '#f9f9f9' },
  center:        { flex: 1, justifyContent: 'center', alignItems: 'center' },
  loadingText:   { marginTop: 12, color: '#888', fontSize: 15 },
  routeBar:      { backgroundColor: '#F5C518', flexDirection: 'row', alignItems: 'center', paddingHorizontal: 20, paddingVertical: 14, gap: 8 },
  routeText:     { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  routeArrow:    { fontSize: 18, color: '#1a1a1a' },
  routeDate:     { fontSize: 13, color: '#444' },
  resultCount:   { fontSize: 13, color: '#888', paddingHorizontal: 16, paddingTop: 12, paddingBottom: 4 },
  card:          { backgroundColor: '#fff', borderRadius: 16, padding: 18, marginBottom: 14, shadowColor: '#000', shadowOpacity: 0.07, shadowRadius: 8, elevation: 3 },
  cardHeader:    { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  cardIcon:      { fontSize: 15, color: '#555' },
  statusBadge:   { borderRadius: 8, paddingHorizontal: 10, paddingVertical: 4 },
  badgeGreen:    { backgroundColor: '#e6f9ed' },
  badgeRed:      { backgroundColor: '#fdecea' },
  statusText:    { fontSize: 12, fontWeight: '600', color: '#2d7a45' },
  cardModelo:    { fontSize: 20, fontWeight: 'bold', color: '#1a1a1a' },
  cardCidade:    { fontSize: 13, color: '#888', marginTop: 2 },
  cardCarga:     { fontSize: 13, color: '#888', marginTop: 2 },
  cardFooter:    { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 14 },
  cardPreco:     { fontSize: 22, fontWeight: '900', color: '#F5C518' },
  cardPrecoDia:  { fontSize: 14, fontWeight: '400', color: '#888' },
  btnVer:        { backgroundColor: '#1a1a1a', borderRadius: 10, paddingHorizontal: 14, paddingVertical: 8 },
  btnVerText:    { color: '#F5C518', fontWeight: 'bold', fontSize: 13 },
  cardProprietario: { marginTop: 10, fontSize: 13, color: '#aaa', borderTopWidth: 1, borderTopColor: '#f0f0f0', paddingTop: 10 },
  empty:         { flex: 1, justifyContent: 'center', alignItems: 'center', padding: 40 },
  emptyIcon:     { fontSize: 56, marginBottom: 16 },
  emptyTitle:    { fontSize: 18, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 8 },
  emptyText:     { fontSize: 14, color: '#888', textAlign: 'center' },
});
